

import React from 'react';
import CustomVisualSettings from './components/pages/CustomVisualSettings';
import { Route, Routes } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './components/auth/authConfig';
import SigninWidget from './components/auth/SigninWidget'
import UserAdministration from './components/pages/UserAdministration'
import PBIReports from './components/reports/PowerBiReports';
import useAutoLogout from './components/auth/AutoLogout';
import PersonaAdministration from './components/pages/PersonaAdministration';
import RolesAdministration from './components/pages/RolesAdministration';
import ReportAdministration from './components/pages/ReportAdministration';
import DepartmentPage from './components/pages/DepartmentPage';
import Overview from './components/pages/Overview';


const App = ({instance}) => {
  const idleWarningDialog = useAutoLogout(); // Automatically logs out after inactivity, warns after 1 minute of inactivity

  
  return (
    <MsalProvider instance={msalInstance}>
        {idleWarningDialog}
        <Routes>
          <Route path="/" element={<SigninWidget />} />
          <Route path="/UserAdministration" element={<UserAdministration />} />
          <Route path="/reports/:ReportID/view" element={<PBIReports/>}/>
          <Route path="/ReportAdministration" element={<ReportAdministration />} />
          <Route path="/RolesAdministration" element={<RolesAdministration />} />
          <Route path="/PersonaAdministration" element={<PersonaAdministration />} />
          <Route path="/DepartmentManagement" element={<DepartmentPage />} />
          <Route path="/settings/visuals" element={<CustomVisualSettings />} />
          <Route path="/overview/:groupid" element={<Overview />} />


        </Routes>
    </MsalProvider>
  );
};

export default App;

